import { useQuery } from '@tanstack/react-query';

import { fetchNewsArticle } from '@/lib/api/news';

export interface UseNewsArticleOptions {
  id: string;
  enabled?: boolean;
}

export function useNewsArticle({ id, enabled = true }: UseNewsArticleOptions) {
  return useQuery({
    queryKey: ['news', id],
    queryFn: ({ signal }) => fetchNewsArticle({ id, signal }),
    enabled: enabled && id.length > 0,
  });
}

